import PropTypes from "prop-types"
import React, { useRef } from "react"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function AppDateInput(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { onChange, value, label, disabled } = props
    const [year, month, day] = value?.split("-")

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const dayRef = useRef()
    const monthRef = useRef()
    const yearRef = useRef()

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function numbersOnly(str) {
        return [...str]
            .filter((l) => {
                return [
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                ].includes(l)
            })
            .join("")
    }

    function handleChange() {
        const day = numbersOnly(dayRef?.current?.value)
        const month = numbersOnly(monthRef?.current?.value)
        const year = numbersOnly(yearRef?.current?.value)
        onChange && onChange({ target: { value: `${year}-${month}-${day}` } })
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={props.className}>
            <span className="label">{label}</span>
            <div className="inputs">
                <input
                    ref={dayRef}
                    value={day}
                    onChange={handleChange}
                    className="input"
                    required
                    min={1}
                    max={31}
                    disabled={disabled}
                />
                <div className="divider" />
                <input
                    value={month}
                    ref={monthRef}
                    onChange={handleChange}
                    className="input"
                    required
                    min={1}
                    max={12}
                    disabled={disabled}
                />
                <div className="divider" />

                <input
                    value={year}
                    ref={yearRef}
                    onChange={handleChange}
                    className="input"
                    required
                    disabled={disabled}
                />
            </div>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

AppDateInput.propTypes = {
    className: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
}

AppDateInput.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledAppDateInput = styled(AppDateInput)`
    & {
        .label {
            font-family: "Poppins-Bold";
            font-size: 14px;
            line-height: 120%;
            position: relative;
            bottom: 3px;
            text-transform: uppercase;
        }
        .inputs {
            border-radius: 6px;
            border: 1px solid ${({ theme }) => theme.colors.inputBorder};
            height: 50px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            padding: 0px 10px;
            .input {
                border: none;
                outline: none;
                background-color: transparent;
                width: 60px;
                height: 40px;
                text-align: center;
                font-family: "Poppins-Regular";
                font-size: 14px;
                &:focus {
                    border: none;
                    outline: none;
                }
            }
            .divider {
                height: 2px;
                background-color: black;
                width: 15px;
                transform: rotate(-60deg);
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledAppDateInput
